import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

export interface UserPrefs {
    preferredTeam?: string;
    channelWorkSessionProposals?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class UserPrefsService {
    private cachedPrefs: UserPrefs | null = null;

    constructor(private http: HttpClient) {}

    get(): Observable<UserPrefs> {
        return this.http.get<UserPrefs>(`${ConfigService.apiUrl}/user/prefs`).pipe(
            tap(prefs => this.cachedPrefs = prefs),
            catchError(() => of({}))
        );
    }

    update(prefs: Partial<UserPrefs>): Observable<UserPrefs> {
        return this.http.post<UserPrefs>(`${ConfigService.apiUrl}/user/prefs`, prefs).pipe(
            tap(updated => this.cachedPrefs = updated)
        );
    }

    setPreferredTeam(teamName: string): Observable<any> {
        return this.http.post(`${ConfigService.apiUrl}/user/prefs/team`, { teamName }).pipe(
            tap(() => {
                if (this.cachedPrefs) {
                    this.cachedPrefs.preferredTeam = teamName;
                }
            })
        );
    }

    getCached(): UserPrefs | null {
        return this.cachedPrefs;
    }
}
